import React, { useState, useEffect } from "react";
import "../refinance/remaining-balance.css";
import { useTransition, animated } from "react-spring";
import ProgressBar from "../../ProgressBar";
import NextBackButton from "../../NextBackButton";

export const DownPayment = ({ formData, setForm, navigation, step }) => {
  const [priceInputValue, setpriceInputValue] = useState(0);
  const [downPaymentAmount, setdownPaymentAmount] = useState(0);
  const [priceInput, setpriceInput] = useState({
    0: 0,
    1: 0.03,
    2: 0.05,
    3: 0.1,
    4: 0.15,
    5: 0.2,
    6: 0.25,
    7: 0.3,
    8: 0.35,
    9: 0.4,
    10: 0.45,
    11: 0.5,
    12: 0.5503,
    13: 0.6,
    14: 0.65,
    15: 0.7,
    16: 0.75,
    17: 0.8,
    18: 0.85,
    19: 0.9,
  });

  useEffect(() => {
    if (formData.downPayment) {
      const amountInDecimal = formData.downPayment / formData.estimatedBudget.replace(/,/g, "");

      console.log(amountInDecimal);

      setpriceInputValue(
        Object.keys(priceInput).find(
          (key) => priceInput[key] === amountInDecimal
        )
      );
    }
  }, []);

  const [isVisible, setIsVisible] = useState(true);
  const [error, setError] = useState(false);

  const transition = useTransition(isVisible, {
    from: { opacity: 0, transform: "translate3d(500px,0px,0)" },
    enter: { opacity: 1, transform: "translate3d(0,0px,0)" },
  });

  useEffect(() => {
    // Ensure estimatedBudget  is available and is a valid number
    if (formData.estimatedBudget && !isNaN(formData.estimatedBudget)) {
      createDownPaymentAmount(formData.estimatedBudget, priceInput[priceInputValue]);
    }
  }, [priceInputValue, formData.estimatedBudget, priceInput]);

  const slider = React.createRef();
  const sliderValue = React.createRef();
  //   console.log(priceInput[priceInputValue]);
  useEffect(() => {
    slider.current.setAttribute("min", 0);
    slider.current.setAttribute("max", Object.keys(priceInput).length - 1);
    const thumbSize = parseInt(
      window
        .getComputedStyle(sliderValue.current)
        .getPropertyValue("--thumb-size"),
      10
    );
    handleSliderValuePosition(slider.current, thumbSize);
  }, [priceInputValue]);

  const handlePricingSlide = (e) => {
    setpriceInputValue(e.target.value);
    handleSliderValuePosition(e.target);
    setError(false);
  };

  useEffect(() => {
    formData.downPayment = downPaymentAmount;
    // console.log(formData.estimatedBudget);
    createDownPaymentAmount(formData.estimatedBudget, priceInput[priceInputValue]);
  }, [priceInputValue]);

  useEffect(() => {
    formData.downPayment = downPaymentAmount;
  }, [downPaymentAmount]);

  const handleSliderValuePosition = (input, thumbSize) => {
    const multiplier = input.value / input.max;
    const thumbOffset = thumbSize * multiplier;
    const priceInputOffset = (thumbSize - sliderValue.current.clientWidth) / 2;
    sliderValue.current.style.left =
      input.clientWidth * multiplier - thumbOffset + priceInputOffset + "px";
  };

  const createDownPaymentAmount = (estimatedBudgetAmount, decimal) => {
    const estimatedBudget = stringToNumber(estimatedBudgetAmount);
    const downPayment = estimatedBudget * decimal;
    setdownPaymentAmount(downPayment);
  };

  const stringToNumber = (string) => {
    return parseInt(string.replace(/[^0-9]/g, ""));
  };

  const addCommas = (number) => {
    let string = number.toFixed(0);
    return string.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  const handleNextAndSubmit = () => {
    formData.downPayment = downPaymentAmount;
    if (formData.downPayment === 0) {
      return setError(true);
    }
    setError(false);
    navigation.next();
  };

  return (
    <div className="flex flex-col h-screen w-full">
      <div>
        <ProgressBar width={"52%"} />
        <div className="flex-grow max-w-7xl mx-auto sm:px-6 lg:px-8 flex justify-center items-center">
          {transition((style, item) =>
            item ? (
              <animated.div style={style} className="mx-auto flex flex-col justify-center items-center">
                <h1 className="lg:pt-10 pt-6 pb-10 text-4xl text-blue-primary font-semibold text-center w-full">
                  What is your estimated down payment?
                </h1>
                <div className="pricing">
                  <div className="pricing-slider center-content">
                    <label className="form-slider">
                      <input
                        type="range"
                        ref={slider}
                        value={priceInputValue}
                        onChange={handlePricingSlide}
                        name="homeValue"
                      />
                    </label>
                  </div>
                  <div ref={sliderValue} className="pricing-slider-value space-y-4">
                    <h2 className="text-4xl font-medium text-gray-satan font-semibold text-center w-full -mt-4">
                      {(priceInput[priceInputValue] * 100).toFixed(0)}%
                    </h2>
                    <h2 className="text-4xl font-medium text-gray-satan font-semibold text-center w-full pb-10">
                      ${addCommas(downPaymentAmount)}
                    </h2>
                  </div>
                </div>
                {error ? (
                  <div className="-mt-6 text-center text-red-error z-50">Please select an estimated down payment</div>
                ) : null}
              </animated.div>
            ) : null
          )}
        </div>
      </div>

      <NextBackButton callBack={handleNextAndSubmit} goBack={() => navigation.previous()} />
    </div>
  );
};

export default DownPayment;
